import React, { FC, useState } from "react";
import { TableRow, TableCell, Grid } from "@material-ui/core";
import { DPButton, DPExportButton } from "Components/DP";

type Props = {
  name: string;
  description: string;
  onDownloadClick: () => void;
  handleExport: () => void;
};

const ReportTableRow: FC<Props> = ({
  name,
  description,
  onDownloadClick,
  handleExport,
}) => {
  const [disabled, setDisabled] = useState(false);

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>{description}</TableCell>
      <TableCell>
        <Grid container spacing={2}>
          <Grid item>
            <DPExportButton
              handleExport={() => {
                handleExport();
                setDisabled(true);
              }}
              disabled={disabled}
            />

          </Grid>
          <Grid item>
            <DPButton onClick={onDownloadClick} size="large">
              Download
            </DPButton>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default ReportTableRow;
